'use client'

import { Radio } from 'fukku/Radio'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import { sendUnitsChangeClick } from '../../analytics/events'
import { useUnit } from '../../contexts/UnitsProvider/UnitsProvider'
import type { SizeGuideUnit } from '../../types'

import styles from './Units.module.scss'

export function Units(): React.ReactNode {
	const { t } = useLabels()
	const { selectedUnit, selectUnit } = useUnit()

	const onUnitChange = (newUnit: string | number): void => {
		sendUnitsChangeClick()
		selectUnit(newUnit as SizeGuideUnit)
	}

	return (
		<Radio
			id='sizeGuide.units.selector'
			legend={t('accessibility.sizeGuide.measureUnit.text')}
			name='units-group'
			className={styles.units}
			options={[
				{ value: 'CM', content: 'cm' },
				{ value: 'PL', content: 'in' },
			]}
			defaultSelected={selectedUnit}
			onChange={onUnitChange}
		/>
	)
}
